import { useState } from "react";
import BulletTextWrapper from "../../details/New_Ui/Component/CurrentPlan/BulletTextWrapper";
import { cn } from "../../../../util/cn";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { updateEmployerNew } from "../../../../data/employer";
import toast from "react-hot-toast";
import { useEffect } from "react";

type TermsPageProps = {
    employerId: string;
    closeModal: () => void;
};

const TermsAndConditionPage = ({
    employerId,
    closeModal
}: TermsPageProps) => {
    const [currentPlanType, setCurrentPlanType] = useState({});
    const [pending, setPending] = useState(false);

    const {
        handleSubmit,
        register,
        formState: { errors, dirtyFields },
        trigger,
    } = useForm({
        defaultValues: {
            signedBy: "",
        },
        resolver: zodResolver(
            z.object({
                signedBy: z
                    .string({ required_error: "Please enter a full name." })
                    .nonempty("Please enter a full name."),
                terms: z.literal(true, {
                    errorMap: () => ({
                        message: "You must accept the terms & conditions.",
                    }),
                }),
            }),
        ),
    });



    async function saveEmployerTerms(data: any) {
        setPending(true);
        await updateEmployerNew(
            employerId,
            { signedBy: data.signedBy },
        )
            .then(() => {
                toast.success("Form Signed");
                closeModal();

            })
            .catch(() => {
                toast.error("There was an error updating Data");
            })
            .finally(() => setPending(false));
    }

    return (
        <div className="">

            {/* <h2 className="text-2xl font-bold text-left mt-[5px] mb-2 text-[#15415E]">
        Terms & Conditions
      </h2> */}
            <form
                className="space-y-8"
                onSubmit={handleSubmit(saveEmployerTerms)}
                autoComplete="off"
            >
                {/* <div>
          <textarea
            readOnly={true}
            className={cn(
              "peer w-full h-[250px] p-4 text-gray-700 text-opacity-60 bg-[#F4F7FA] rounded-lg shadow-sm border border-transparent focus:border-[#15415E] focus:ring-0 placeholder-gray-400 resize-none",
              {
                "cursor-not-allowed": true,
              },
            )}
            value={termsText}
          />
        </div> */}
                {/* Terms and Conditions */}
                <div className="relative mb-7 mt-[40px] items-start">
                    <div className="flex items-center h-5">
                        <input
                            type="checkbox"
                            name="terms"
                            ref={register({
                                required: "Please agree to our terms of service.",
                            })}
                            className="h-4 w-4 text-[#15415E] focus:ring-gray-500 border-gray-600 rounded"
                        />

                        <label htmlFor="terms" className="text-[#616161] ml-3 text-sm">
                            I agree to the{" "}
                            <a
                                // href="https://instantteams.com/terms-and-conditions/"
                                href="https://firebasestorage.googleapis.com/v0/b/stage-firebase-project.appspot.com/o/pdfs%2FInstant%20Teams%20-%20Job%20Board%20Advertiser%20Agreement%201.14.25.pdf?alt=media&token=20738c19-c0ef-4368-a0e6-805de2271db8"
                                target="_blank"
                                className="text-[#15415E] underline"
                                rel="noreferrer"
                            >
                                Terms and Conditions
                            </a>{" "}
                            associated with the selected package
                        </label>
                    </div>
                    {errors.terms && (
                        <p className="mt-1 text-sm text-left text-red-600">
                            {errors.terms.message}
                        </p>
                    )}
                </div>
                <div className="relative  mb-7">
                    <input
                        type="text"
                        name="signedBy"
                        placeholder="" // Empty placeholder for floating effect
                        ref={register({
                            required: "Please enter your full name.",
                        })}
                        //onChange={async () => await trigger("signedBy")}
                        onBlur={async () => await trigger("signedBy")}
                        className="peer mt-10 mb-10  block w-full px-3 inp py-2 rounded-none sm:text-sm"
                        style={{ boxShadow: "none" }}
                    />
                    <label
                        htmlFor="signedBy"
                        className="absolute -top-4 text-sm text-[#15415E] bg-white px-1 transition-all duration-200 peer-placeholder-shown:top-2 peer-placeholder-shown:text-[#15415E] peer-placeholder-shown:text-sm peer-focus:-top-4 peer-focus:text-[#15415E] peer-focus:text-sm"
                    >
                        Signed By <span className="text-red-600">*</span>
                    </label>
                    {dirtyFields.signedBy && errors.signedBy && (
                        <p className="mt-1 text-sm text-left text-red-600">
                            {errors.signedBy.message}
                        </p>
                    )}
                </div>
                {/* Submit Button */}
                <div className="flex justify-center">
                    <button
                        type="submit"
                        className={`py-3 px-8  text-white font-medium rounded-2xl focus:outline-none focus:ring-2 bg-[#15415E]`}
                        style={{ width: "200px" }}
                        disabled={pending}
                    >
                        {pending ? (
                            <div className="flex items-center justify-center space-x-2">
                                <svg
                                    className="animate-spin h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            </div>
                        ) : (
                            "Continue"
                        )}
                    </button>
                </div>
            </form>
            
        </div>
    );
};

export default TermsAndConditionPage;
